// extracted by mini-css-extract-plugin
module.exports = {"control":"styles_control__jTBMo"};